import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { DeliveryDeviceService } from 'app/services/models/delivery-device.service';
import { DeliveryService } from 'app/services/models/delivery.service';

import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import htmlToPdfmake from 'html-to-pdfmake';
import { TDocumentDefinitions } from 'pdfmake/interfaces';

(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-delivery-detail',
  templateUrl: './delivery-detail.component.html',
  styleUrls: ['./delivery-detail.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DeliveryDetailComponent implements OnInit,AfterViewInit  {
  @ViewChild('printRef', { static: false }) printRef!: ElementRef;

  rows: any[] = [];
  deviceList: any[] = [];
  delivery: any = {};

  constructor(
    private deliveryService: DeliveryService,
    private activatedRouter: ActivatedRoute,
    private deliveryDevice: DeliveryDeviceService
  ) { }

  ngAfterViewInit() {
    // printRef artık DOM'da mevcut, burada ek bir işlem yapmaya gerek yok.
  }

  async ngOnInit() {
    this.activatedRouter.params.subscribe(async params=>{
      await this.getByIdDelivery(params['id']);
    });
  }

  async getByIdDelivery(id) {
    const data = await this.deliveryService.getByIdDelivery(id);
    this.delivery = data;
    console.log(this.delivery);
    await this.getDeliveryByIdDevices(0, 100, this.delivery.id);
  }

  async getDeliveryByIdDevices(page, size, id) {
    const data = await this.deliveryDevice.getDeliveryByIdDevices(page, size, id);
    console.log(data);
    this.rows = data.deliveryDevices;
  }

  downloadPDF() {
    if (!this.printRef) {
      console.error('printRef referansı bulunamadı.');
      return;
    }
    
    // PDF'ye dönüştürmek istediğimiz HTML içeriğini alıyoruz:
    const htmlContent = this.printRef.nativeElement.innerHTML;
    
    // İsteğe bağlı olarak arka planı beyaz yapacak ek bir stil ekleyebilirsiniz:
    const modifiedHtml = `<div style="background: #ffffff; padding: 10px;">${htmlContent}</div>`;
    
    // html-to-pdfmake ile HTML içeriğini pdfmake formatına çeviriyoruz.
    const pdfContent = htmlToPdfmake(modifiedHtml, {
      defaultStyles: {
        body: { fontSize: 12, color: '#000000' }
      }
    });
    
    const docDefinition: TDocumentDefinitions = {
      pageSize: 'A4' as 'A4',
      pageMargins: [20, 20, 20, 20] as [number, number, number, number],
      content: [
        {
          columns: [
            {
              text: 'Şirket Adı: XYZ Ltd.',
              width: '50%',
              style: 'headerText'
            },
            {
              text: 'Bağlı Proje: Proje A',
              width: '50%',
              style: 'headerText'
            }
          ],
          margin: [0, 0, 0, 10]
        },
        {
          columns: [
            {
              text: 'Bağlı Talep: Talep 123',
              width: '50%',
              style: 'headerText'
            },
            {
              text: 'Başlangıç Tarihi: 01/01/2025',
              width: '50%',
              style: 'headerText'
            }
          ],
          margin: [0, 0, 0, 10]
        },
        {
          columns: [
            {
              text: 'Bitiş Tarihi: 31/12/2025',
              width: '50%',
              style: 'headerText'
            },
            {
              text: 'Diğer Bilgiler: Test Bilgisi',
              width: '50%',
              style: 'headerText'
            }
          ],
          margin: [0, 0, 0, 10]
        },
        {
          text: 'Açıklamalar: Detaylı açıklama yazısı burada yer alacak.',
          margin: [0, 10, 0, 20],
          style: 'bodyText'
        }
      ],
      styles: {
        headerText: {
          fontSize: 14,
          bold: true,
          color: '#333333',
          alignment: 'left'
        },
        bodyText: {
          fontSize: 12,
          color: '#000000',
          alignment: 'left'
        }
      }
    };
    pdfMake.createPdf(docDefinition).open();
  }
}